import moment from "moment";
import "moment-timezone";

export const formatDateTime = (inputDate) => {
  const date = new Date(inputDate);

  const options = {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  const formatter = new Intl.DateTimeFormat("en-US", options);
  const formattedDate = formatter.format(date);

  const [datePart, timePart] = formattedDate.split(", ");
  const [month, day, year] = datePart.split("/");
  const formattedTime = timePart.slice(0, -3);

  return `${year}/${month}/${day}, ${formattedTime}`;
};

export const getCurrentDateTime = () => {
  const currentDate = new Date();
  const formattedDateTime = currentDate
    .toISOString()
    .replace("T", " ")
    .slice(0, -1);
  return formattedDateTime;
};

export function formatDateToYYYYMMDD(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export const getDateInFormat = (date) => {
  var finalDate =
    date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate();
  return finalDate;
};

export function getDateFromWeek(year, weekNumber) {
  const januaryFirst = new Date(year, 0, 1);
  const dayOfWeek = januaryFirst.getDay();
  const daysUntilMonday = dayOfWeek === 0 ? 1 : 8 - dayOfWeek;
  const firstMonday = new Date(januaryFirst);
  firstMonday.setDate(januaryFirst.getDate() + daysUntilMonday);
  // Calculate the start date of the specified week
  const daysToAdd = (weekNumber - 1) * 7;
  const resultDate = new Date(firstMonday);

  const getFirstMondayOfWeek = resultDate.setDate(
    firstMonday.getDate() + daysToAdd
  );
  const startWeekDate = new Date(getFirstMondayOfWeek);
  startWeekDate.setDate(startWeekDate.getDate() + 6);

  const startDate = getDateInFormat(resultDate);
  const endDate = getDateInFormat(startWeekDate);

  return { startDate, endDate };
}

export function getStartEndDate(year, weekNumber) {
  var januaryFirst = new Date(year, 0, 1);

  var dayOfWeek = januaryFirst.getDay();

  var daysToFirstWeekDay = 1 - dayOfWeek;

  var startOfWeek = new Date(januaryFirst);
  startOfWeek.setDate(
    januaryFirst.getDate() + daysToFirstWeekDay + 7 * (weekNumber - 1)
  );

  var endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);

  function formatDate(date) {
    var yyyy = date.getFullYear();
    var mm = (date.getMonth() + 1).toString().padStart(2, "0");
    var dd = date.getDate().toString().padStart(2, "0");
    return `${mm}/${dd}`;
  }

  return {
    startDate: formatDate(startOfWeek),
    endDate: formatDate(endOfWeek),
  };
}

export const getWeekFromDate = (dateString) => {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "Invalid date";
  }

  const year = date.getFullYear();
  const weekNumber = getISOWeekNumber(date);
  const formattedWeek = `${year}-W${weekNumber.toString().padStart(2, "0")}`;

  return formattedWeek;
};

const getISOWeekNumber = (date) => {
  const dt = new Date(date);
  dt.setDate(dt.getDate() + 4 - (dt.getDay() || 7));
  const yearStart = new Date(dt.getFullYear(), 0, 1);
  const weekNumber = Math.ceil(((dt - yearStart) / 86400000 + 1) / 7);

  return weekNumber;
};

export function parseTime(timeString) {
  const [hours, minutes, seconds] = timeString.split(":").map(Number);

  const ampm = hours >= 12 ? "PM" : "AM";

  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;

  return {
    hour: formattedHours,
    minutes,
    ampm,
  };
}

export const formatTimeEntry = (timeData, type) => {
  let { hours, minutes, ampm } = timeData;

  let formattedHours = hours;
  if (ampm === "PM" && hours !== 12) {
    formattedHours += 12;
  } else if (ampm === "AM" && hours === 12) {
    formattedHours = 0;
  }

  if (type === "entryTimeOut" || type === "lunchTimeOut") {
    if (formattedHours === 0 && minutes === "00" && ampm === "AM") {
      return "24:00";
    }
  } else if (type === "entryTimeIn" || type === "lunchTimeIn") {
    if (formattedHours === 0 && minutes === "00" && ampm === "AM") {
      return "00:00";
    } else if (formattedHours === 0 && minutes === "30" && ampm === "AM") {
      return "00:30";
    }
  }

  return `${formattedHours}:${minutes}`;
};

export const formatTimeForBackend = (timeData) => {
  let { hours, minutes, ampm } = timeData;
  let formattedHours = hours;
  if (ampm === "PM" && hours !== 12) {
    formattedHours += 12;
  } else if (ampm === "AM" && hours === 12) {
    formattedHours = 0;
  }

  if (formattedHours < 10) {
    formattedHours = "0" + formattedHours;
  }

  return `${formattedHours}:${minutes}`;
};

export const getDatesForISOWeek = (isoWeekString) => {
  const [isoYear, isoWeek] = isoWeekString?.split("-W");

  const startOfWeek = moment()
    .isoWeekYear(isoYear)
    .isoWeek(isoWeek)
    .startOf("isoWeek")
    .local();

  const dates = [];
  for (let i = 0; i < 7; i++) {
    dates.push(startOfWeek.clone().add(i, "days").toDate());
  }

  return dates;
};

export const getWeekNumber = (dateString) => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const date = moment.tz(dateString, userTimezone);
  const weekNumber = date.isoWeek();
  const year = date.isoWeekYear();
  return `${year}-W${weekNumber.toString().padStart(2, "0")}`;
};

export const convertHoursToMinutes = (time) => {
  let totalMinutes = "";
  const str = time.split(".");
  const hourStr = str[0];
  const minuteStr = str[1];
  totalMinutes += parseInt(hourStr * 60) + parseInt(minuteStr);
  return totalMinutes;
};

export const convertMinutesToHours = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  const result = hours + "." + remainingMinutes;
  return result;
};

export const convertDateToUserTimezone = (dateString) => {
  const userTimezone = Intl.DateTimeFormat()?.resolvedOptions()?.timeZone;
  const date = moment?.tz(dateString, "YYYY-MM-DD", userTimezone);
  return date?.format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
};

export const getDayName = (dateString) => {
  const date = moment(dateString);

  if (!date.isValid()) {
    throw new Error("Invalid date format");
  }

  const dayName = date.format("dddd");

  return dayName;
};

export function getTodayFormatted() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}
export function subtractAndAbs(value1, value2) {
  const result = value1 - value2;
  const absResult = Math.abs(result);
  return Math.round(absResult * 100) / 100;
}

export const slashSpace = (str) => {
  let newStr = "";
  const indexOfSlash = str.indexOf("/");
  if (indexOfSlash >= 0) {
    newStr = str.slice(0, indexOfSlash) + " " + str.slice(indexOfSlash);
    return newStr;
  } else {
    return str;
  }
};

export function convertTimesToMinutes(time) {
  let [hours, minutes] = time?.split(":")?.map(Number);
  return hours * 60 + minutes;
}

export function convertTo12Hour(time) {
  let [hours, minutes] = time.split(":");
  hours = parseInt(hours);
  const period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${hours}:${minutes} ${period}`;
}

export function formatToWeekYear(dateString, separator) {
  const date = new Date(dateString);
  const currentThursday = new Date(date);
  currentThursday.setDate(date.getDate() + (4 - (date.getDay() || 7)));
  const firstThursday = new Date(currentThursday.getFullYear(), 0, 1);
  firstThursday.setDate(
    firstThursday.getDate() + (4 - (firstThursday.getDay() || 7))
  );
  const weekNumber = Math.ceil(
    (currentThursday - firstThursday) / (7 * 24 * 60 * 60 * 1000) + 1
  );
  const formattedWeekYear = `${currentThursday.getFullYear()}${
    separator ? separator : "/"
  }${separator ? "W" : ""}${weekNumber.toString().padStart(2, "0")}`;

  return formattedWeekYear;
}

export function getCurrentAndPreviousWeek() {
  const today = new Date();
  const previousWeekDate = new Date(today);
  today.setHours(0, 0, 0, 0);
  previousWeekDate.setDate(today.getDate() - 14);
  previousWeekDate.setHours(0, 0, 0, 0);
  return [today, previousWeekDate];
}

export function getTodayDate() {
  const today = new Date();

  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const yy = String(today.getFullYear()).slice(-2);

  return `${dd}-${mm}-${yy}`;
}

export function formatDateToMMDDYYYY(isoDateStr) {
  const date = new Date(isoDateStr);

  const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = date.getFullYear();

  return mm && dd && yyyy ? `${mm}/${dd}/${yyyy}` : "";
}

export function formatUTCDateToMMDDYYYY(isoDateStr) {
  const date = new Date(isoDateStr);

  const mm = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
  const dd = String(date.getUTCDate()).padStart(2, "0");
  const yyyy = date.getUTCFullYear();

  return `${mm}/${dd}/${yyyy}`;
}

export function convertToISOString(date) {
  if (!(date instanceof Date) || isNaN(date)) {
    throw new Error("Invalid date");
  }
  return date.toISOString();
}

export function extractDateFromISO(isoDateString) {
  if (!isoDateString) {
    return null;
  }
  return isoDateString.split('T')[0];
}
